<template>
    <div class="page">
        <div class="login" style="overflow: hidden">
            <div class="line-graphics--group01" aria-hidden="true"></div>
            <div class="line-graphics--group02" aria-hidden="true"></div>
            <div class="line-graphics--group03" aria-hidden="true"></div>
            <div class="line-graphics--group04" aria-hidden="true"></div>

            <div class="login-box">
                <div class="login-box__header">
                    <div class="logo">
                        <a href="/"
                            ><img
                                src="/img/welcome/logos/doffero-logo-v2.svg"
                                class="mx-auto"
                                :alt="$t('other_woutlog.login_text_1')"
                        /></a>
                    </div>
                    <h1 class="title">
                        {{ $t("other_woutlog.login_text_2") }}
                    </h1>
                    <p class="subtext">
                        {{ $t("other_woutlog.login_text_3") }}
                        <a href="/registracia">{{
                            $t("other_woutlog.login_text_4")
                        }}</a>
                    </p>
                </div>

                <div class="login-box__body">
                    <form
                        class="form form--login"
                        method="POST"
                        action="/prihlasenie"
                    >
                        <input type="hidden" name="_token" :value="user.csrf" />
                        <div class="form-group">
                            <div
                                class="input-wrapper"
                                v-bind:class="{ 'has-error': errors.email }"
                            >
                                <label class="form__label" :class="{ 'is-jumped': emailAutoFill }" for="email">{{
                                    $t("other_woutlog.register_text_23")
                                }}</label>
                                <input
                                ref="emailInput"
                                    v-model="user.email"
                                    class="form__input"
                                    name="email"
                                    type="email"
                                    id="email"
                                />
                            </div>
                        </div>
                        <div class="form-group form-group--last">
                            <div
                                class="input-wrapper"
                                v-bind:class="{ 'has-error': errors.password }"
                            >
                                <label class="form__label" :class="{ 'is-jumped': passwordAutoFill }" for="heslo">{{
                                    $t("other_woutlog.register_text_24")
                                }}</label>
                                <input
                                ref="passwordInput"
                                    class="form__input pass"
                                    name="password"
                                    type="password"
                                    id="heslo"
                                    v-model="user.password"
                                />
                                <div class="password-toggle js-password-show">
                                    <i class="eye" data-target="#heslo"></i>
                                </div>
                            </div>
                        </div>
                        <span v-show="error" class="error-msg">
                            <svg
                                width="16"
                                height="14"
                                viewBox="0 0 16 14"
                                fill="none"
                            >
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M6.25709 1.099C7.02209 -0.260998 8.97909 -0.260998 9.74309 1.099L15.3231 11.019C16.0731 12.353 15.1101 13.999 13.5811 13.999H2.42009C0.890093 13.999 -0.0729075 12.353 0.677092 11.019L6.25709 1.099ZM9.00009 11C9.00009 11.2652 8.89474 11.5196 8.7072 11.7071C8.51966 11.8946 8.26531 12 8.00009 12C7.73488 12 7.48052 11.8946 7.29299 11.7071C7.10545 11.5196 7.00009 11.2652 7.00009 11C7.00009 10.7348 7.10545 10.4804 7.29299 10.2929C7.48052 10.1054 7.73488 10 8.00009 10C8.26531 10 8.51966 10.1054 8.7072 10.2929C8.89474 10.4804 9.00009 10.7348 9.00009 11ZM8.00009 3C7.73488 3 7.48052 3.10536 7.29299 3.2929C7.10545 3.48043 7.00009 3.73479 7.00009 4V7C7.00009 7.26522 7.10545 7.51957 7.29299 7.70711C7.48052 7.89465 7.73488 8 8.00009 8C8.26531 8 8.51966 7.89465 8.7072 7.70711C8.89474 7.51957 9.00009 7.26522 9.00009 7V4C9.00009 3.73479 8.89474 3.48043 8.7072 3.2929C8.51966 3.10536 8.26531 3 8.00009 3Z"
                                    fill="#E83C58"
                                />
                            </svg>
                            {{ error }}
                        </span>
                        <div class="form-helper">
                            <p>
                                <a
                                    href="/password/reset"
                                    class="link-nodecore"
                                    >{{ $t("other_woutlog.login_text_5") }}</a
                                >
                            </p>
                        </div>
                        <div class="form-submit">
                            <button
                                type="submit"
                                @click="login($event)"
                                class="btn--primary"
                            >
                                {{ $t("other_woutlog.login_text_6") }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <!-- /. login -->
    </div>
</template>

<script>
export default {
    props: ["chyba"],
    data() {
        return {
            user: {
                csrf: document
                    .querySelector('meta[name="csrf-token"]')
                    .getAttribute("content"),
                email: "",
                password: "",
                remember: true,
            },
            errors: {
                email: false,
                password: false,
            },
            error: "",
            lang: this.$i18n.locale,
            emailAutoFill: false,
            passwordAutoFill: false
        };
    },
    mounted() {
        setTimeout(() => {
            this.checkAutofill();
        }, 500);
    },
    methods: {
        checkAutofill() {
            const emailInput = this.$refs.emailInput;
            const passwordInput = this.$refs.passwordInput;
            if (emailInput) {
                const style = window.getComputedStyle(emailInput);
                if (style.borderColor === 'rgb(224, 224, 225)') { 
                    this.emailAutoFill = true
                }
            }
            if (passwordInput) {
                const style = window.getComputedStyle(passwordInput);
                if (style.borderColor === 'rgb(224, 224, 225)') { 
                    this.passwordAutoFill = true
                }
            }
        },
        checkError() {
            if (!this.user.email) this.errors.email = true;
            if (!this.user.password) this.errors.password = true;
        },
        login(event) {
            this.errors.email = false;
            this.errors.password = false;
            this.error = "";
            //this.checkError()
            if (this.errors.email || this.errors.password) {
                event.preventDefault();
            }
        },
    },
    created() {
        if (this.chyba) {
            this.error = this.chyba;
            this.errors.email = true;
            this.errors.password = true;
        }
    },
};
</script>
<style lang="scss">
input:autofill,
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0px 1000px #ffffff inset !important;
}
#email:autofill,
#email:-webkit-autofill,
#email:-webkit-autofill:hover,
#email:-webkit-autofill:focus,
#email:-webkit-autofill:active {
    border: 1px solid rgb(224, 224, 225);
}
#heslo:autofill,
#heslo:-webkit-autofill,
#heslo:-webkit-autofill:hover,
#heslo:-webkit-autofill:focus,
#heslo:-webkit-autofill:active {
    border: 1px solid rgb(224, 224, 225);
}
</style>e
<style lang="scss" scoped>
button {
    cursor: pointer;
    color: #fff !important;
}
.login {
    overflow: hidden;
    @media only screen and (max-height: 450px) {
        overflow-y: auto;
    }
}
</style>
